import { forwardRef } from 'react';

import { cn, PropsOf } from '../../style-system';

type ModalBodyProps = PropsOf<'div'> & {
    /** if the modal contains a popover/select, this will make sure the menu is interactable */
    overflowVisible?: boolean;
};

const ModalBody = forwardRef<HTMLDivElement, ModalBodyProps>(function ModalBody(
    { children, className, overflowVisible = false, ...rest },
    ref,
) {
    return (
        <div
            {...rest}
            ref={ref}
            className={cn(
                'w-full scroller h-full flex flex-col flex-grow p-4 items-stretch overflow-auto',
                {
                    'overflow-visible': overflowVisible,
                },
                className,
            )}
        >
            {children}
        </div>
    );
});

export type { ModalBodyProps };
export { ModalBody };
